import BaseModal from 'app/views/modals/base_modal';

import tmpl from 'templates/bank_account_verification_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .verify_amounts': 'verifyAccount',
  },

  verifyAccount(event) {
    event.preventDefault();
    const amounts = [];
    this.$('select.verification_amount').each((i, el) => {
      amounts.push($(el).val());
    });
    this.model.verify(amounts);
    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/bank_account_verification_modal.js